import { useCustomQuery } from "utilities/hookutils";

export const useStatuses = (mainArea: server.dto.MainAreas, clientId: number) => {
  const statusQuery = useCustomQuery({
    queryFn: async () => window.CoreApi.Status.ListSmall({ clientId, mainArea }).then(r => r.data.data),
    queryKey: ["statuses", mainArea, clientId]
  });

  return statusQuery;
}

export const useHasMultipleStatuses = (mainArea: server.dto.MainAreas, clientId: number) => {
  const statusQuery = useStatuses(mainArea, clientId);
  if (statusQuery.isLoading) {
    return true;
  }
  return statusQuery.data.length > 1;
}